export default __webpack_public_path__ + "static/media/trans-1.69a168e7.jpg";